import apiClient from './api';

export const insertSearchStat = (userId, browser) => apiClient.post(`/statistic/insert/search-stat`, { userId, browser });

export const insertTileStat = (userId, tileId) => apiClient.post(`/statistic/insert/tile-stat`, { userId, tileId });

export const insertConnectionStat = (userId) => apiClient.post(`/statistic/insert/connection-stat`, { userId });

export const insertUserConnectionStat = (userId, at, endpoint) => apiClient.post(`/statistic/insert/user-connection-stat`, { userId, at, endpoint });

export const getUserConnectionStats = () => apiClient.get(`/statistic/get/user-connection-stats`);
